import React from 'react'

const BkFlowNavigationProfileMenuError = (props) => {
	const {
		hotelLabels,
		handleFetchProfileUser
	} = props

	return  (
		<div className="bk-flow-navigation__profile-menu-error">
			<p className="u-txt-center">
				{ hotelLabels &&
					hotelLabels.profileUserErrorMessage ?
						hotelLabels.profileUserErrorMessage
				:
					'There was an error retrieving your account details. Please wait a moment and try again.'
				}
			</p>
			<button
				className="btn"
				onClick={() => handleFetchProfileUser()}
			>
				{ hotelLabels && hotelLabels.retry ? hotelLabels.retry : 'Retry' }
			</button>
		</div>
	)
}

export default BkFlowNavigationProfileMenuError


// WEBPACK FOOTER //
// ./src/components/structure/navigation/profile/BkFlowNavigationProfileMenuError.js